export const details = 'collicare-user-details';
export const view = 'collicare-user-view';
